import { Description } from "@mui/icons-material";
import { TableCell, useMediaQuery, useTheme } from "@mui/material";
import { isAndroid, isMobileSafari } from "react-device-detect";
import { useState } from "react";
import { GetBinary } from "../../services/fhir/patientsummary/Binary/GetBinary";
import { IframeDialog } from "../ehrrecords/components/IframeDialog";
import {
  TableActionButton,
  TableActionGroup,
} from "../../components/GenericTable/TableActionButton";

export function AccessHistoryActions({ row }: any) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const [binaryUrl, setBinaryUrl] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setBinaryUrl("");
    setOpen(false);
  };

  const base64ToBlob = (base64: any, contentType = "") => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  async function downloadBase64File() {
    try {
      const response = await GetBinary({
        urlBinary: row?.binaryUrl,
      });
      const blob = base64ToBlob(response?.data, response?.contentType);
      const fileUrl = URL.createObjectURL(blob);
      const auxFile = {
        fileUrl,
        fileName: "Documento.pdf",
      };

      if (isMobileSafari && !isAndroid) {
        if (auxFile) {
          const link = document.createElement("a");
          link.href = auxFile?.fileUrl;
          link.download = auxFile?.fileName;
          link.click();
        } else {
          alert(
            "O arquivo ainda está sendo preparado, por favor tente novamente."
          );
        }
      } else {
        window.open(auxFile.fileUrl, "_blank");
        handleClose();
      }
    } catch (err) {
      console.log("err", err);
    }
  }

  if (!row?.binaryUrl) return null;

  const actionBar = (
    <TableActionGroup fullWidth={isMobileLayout}>
      <TableActionButton
        compact={!isMobileLayout}
        icon={<Description />}
        label="Ver documento"
        tone="primary"
        onClick={
          isMobileLayout
            ? () => downloadBase64File()
            : () => {
                setBinaryUrl(row?.binaryUrl);
                setOpen(true);
              }
        }
      />
    </TableActionGroup>
  );

  const dialog = open ? (
    <IframeDialog handleClose={handleClose} isOpen={open} data={binaryUrl} />
  ) : null;

  if (isMobileLayout) {
    return (
      <>
        {actionBar}
        {dialog}
      </>
    );
  }

  return (
    <>
      <TableCell align="center" sx={{ verticalAlign: "middle" }}>
        {actionBar}
      </TableCell>
      {dialog}
    </>
  );
}
